module.exports = __webpack_public_path__ + "static/media/avenir-next-demi.553decd4.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avenir-next-demi.otf
// module id = 1028
// module chunks = 3